// Valor de una celda-día SIN CARGAR: ni siquiera se decidió qué hace la persona ese día.
// Ojo que no es lo mismo que un franco: el franco es una decisión y tiene su propio código.
export const CELDA_VACIA = { codigo: "", observacion: "" };

/**
 * Los cinco valores posibles de una celda-dia.
 *
 * Los tres primeros son turnos de trabajo; franco y licencia son dias NO trabajados y por eso
 * no tienen horario ni suman horas. Estan en la misma lista igual porque, desde la celda, los
 * cinco son lo mismo: una opcion que se elige para ese dia.
 *
 * `horario` es para mostrar y `horas` para sumar. Van los dos porque son dos usos distintos:
 * parsear el string en cada celda para contar seria caro y fragil —y el turno N cruza la
 * medianoche, asi que la resta directa daria negativo.
 */
export const TURNOS = [
    { codigo: "M", label: "Mañana", horario: "06:00 a 14:00", horas: 8 },
    { codigo: "T", label: "Tarde", horario: "14:00 a 22:00", horas: 8 },
    { codigo: "N", label: "Noche", horario: "22:00 a 06:00", horas: 8 },
    { codigo: "F", label: "Franco", horario: null, horas: 0 },
    { codigo: "L", label: "Licencia", horario: null, horas: 0 },
];

/** Cuantas horas suma un codigo. 0 para franco, licencia, vacio o cualquier cosa rara. */
export const horasDelTurno = (codigo) =>
    TURNOS.find((t) => t.codigo === codigo)?.horas ?? 0;

/**
 * Si ese dia la persona TRABAJA.
 *
 * Se deriva de las horas en vez de listar M/T/N a mano: asi un turno nuevo con horas queda
 * contado solo, y franco y licencia quedan afuera sin tener que acordarse de excluirlos.
 */
export const esDiaTrabajado = (codigo) => horasDelTurno(codigo) > 0;

/**
 * Valores de una celda de TURNOS EXTRAORDINARIOS (TEx), que es la otra solapa.
 *
 * Son guardias, no la grilla semanal: la mayoria de los dias no tiene nada, y por eso no
 * existen aca ni el franco ni la licencia — si no hubo guardia, la celda va vacia.
 *
 * Los compuestos son UN codigo, no dos: `"M/T"` es un valor mas de esta lista, igual que
 * `"M"`. Modelarlo como un array de codigos complicaria el editor, el render y el conteo sin
 * ganar nada, porque las combinaciones posibles son tres y estan cerradas.
 *
 * Esas tres son los pasajes "hacia adelante" en el orden mañana → tarde → noche → mañana: una
 * guardia que empieza en un turno y sigue en el siguiente. Las otras combinaciones no existen
 * operativamente.
 */
export const TURNOS_EXTRA = [
    { codigo: "M", label: "Mañana" },
    { codigo: "T", label: "Tarde" },
    { codigo: "N", label: "Noche" },
    { codigo: "M/T", label: "Mañana y tarde" },
    { codigo: "T/N", label: "Tarde y noche" },
    { codigo: "N/M", label: "Noche y mañana" },
];

// `abrev` son las dos letras del encabezado de la grilla; `label` el nombre entero, para
// titulos y lugares donde el ancho no aprieta. Dos letras y no tres porque es lo que deja
// la columna del dia en la mitad de ancho, que es lo que hace que entren el doble de dias
// sin scrollear. Alcanzan para distinguirlos: Ma/Mi y Ju/Vi no se pisan.
export const DIAS = [
    { key: "lunes", label: "Lunes", abrev: "Lu" },
    { key: "martes", label: "Martes", abrev: "Ma" },
    { key: "miercoles", label: "Miércoles", abrev: "Mi" },
    { key: "jueves", label: "Jueves", abrev: "Ju" },
    { key: "viernes", label: "Viernes", abrev: "Vi" },
    { key: "sabado", label: "Sábado", abrev: "Sá" },
    { key: "domingo", label: "Domingo", abrev: "Do" },
];
